import { render, staticRenderFns } from "./CarrierLabelView.vue?vue&type=template&id=50b8af62&"
import script from "./CarrierLabelView.vue?vue&type=script&lang=js&"
export * from "./CarrierLabelView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports